/**
 * フック実行結果表示カード（管理アプリ用）
 *
 * 表示本体は @kyumo/shared-ui の HookExecutionView へ共通化（desktop/web で共用）。
 * 管理ビューアでは監査証跡確認のため既定で開いて表示する。
 */

import { HookExecutionView } from '@kyumo/shared-ui';
import type { HookEventPart } from './task-detail-types';

export function HookExecutionCard({ part }: { part: HookEventPart }) {
  return <HookExecutionView event={part} defaultOpen />;
}
